import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  class: "row",
  id: "#newFormLink"
}
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-striped table-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Ações "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Tag "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Label"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Url ")
  ])
], -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "mt-1 mb-1" }
const _hoisted_18 = { class: "mb-3 text-center" }
const _hoisted_19 = { class: "row g-3" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "tag" }, "Tag", -1)
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "Subject" }, "Label", -1)
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "URL", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "row align-items-center" }
const _hoisted_28 = { class: "mb-1 mt-1" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Criar Link")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Cancelar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "can-cancel": true,
        "is-full-page": true
      }, null, 8, ["active"])
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "hidden",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.cliptext) = $event))
    }, null, 512), [
      [_vModelText, $setup.cliptext]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.links, (lk) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: lk.id
              }, [
                _createElementVNode("td", null, [
                  (!($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        id: "#copylink",
                        title: "Copiar link",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toClipboard($setup.data.tag)))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "copy" })
                      ]))
                    : _createCommentVNode("", true),
                  (!($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        id: "#alterarlinkid",
                        title: "Alterar link",
                        onClick: ($event: any) => ($setup.AlterarLink(lk.id))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                      ], 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        id: "#alterarlinkid",
                        title: "Salvar alteração",
                        onClick: ($event: any) => ($setup.SalvarAlterarLink(lk.id))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "save" })
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        id: "#alterarlinkid",
                        title: "Cancelar alteração",
                        onClick: ($event: any) => ($setup.CancelarAlterarLink(lk.id))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "ban" })
                      ], 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (!($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 4,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        id: "#deletelink",
                        title: "Excluir link",
                        onClick: ($event: any) => ($setup.ExcluirLink(lk.id,lk.tag))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "trash-alt" })
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  (!($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(lk.tag), 1))
                    : _createCommentVNode("", true),
                  ($setup.chooselk==lk.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.tag) = $event)),
                          class: "form-control",
                          id: "tag",
                          type: "text",
                          name: "tag",
                          required: ""
                        }, null, 512), [
                          [_vModelText, $setup.data.tag]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  (!($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(lk.label), 1))
                    : _createCommentVNode("", true),
                  ($setup.chooselk==lk.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.label) = $event)),
                          class: "form-control",
                          id: "subject",
                          type: "text",
                          name: "label",
                          required: ""
                        }, null, 512), [
                          [_vModelText, $setup.data.label]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  (!($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(lk.link.url), 1))
                    : _createCommentVNode("", true),
                  (($setup.chooselk==lk.id))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.link_id) = $event)),
                          class: "form-select",
                          id: "link_id",
                          "aria-label": "multiple select example"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.urls, (url) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: url.id,
                              value: url.id
                            }, _toDisplayString(url.name), 9, _hoisted_16))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, $setup.data.link_id]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ], 512), [
        [_vShow, $setup.showlinks]
      ])
    ], 512), [
      [_vShow, !$setup.janela]
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h1", null, [
          _withDirectives(_createElementVNode("a", {
            href: "javascript:void(0)",
            class: "text-muted text-decoreation-none",
            id: "#newLinkForm",
            title: "Criar Link",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showNewLinkForm()))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
          ], 512), [
            [_vShow, !$setup.janela]
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.tag) = $event)),
            class: "form-control",
            id: "tag",
            type: "text",
            name: "tag"
          }, null, 512), [
            [_vModelText, $setup.data.tag]
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.label) = $event)),
            class: "form-control",
            id: "subject",
            type: "text",
            name: "label"
          }, null, 512), [
            [_vModelText, $setup.data.label]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.link_id) = $event)),
            class: "form-select",
            id: "typeaction",
            "aria-label": "multiple select example"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.urls, (url) => {
              return (_openBlock(), _createElementBlock("option", {
                key: url.id,
                value: url.id
              }, _toDisplayString(url.name), 9, _hoisted_26))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.data.link_id]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "btn btn-outline-secondary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.CriarLink()))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "ban" }),
            _hoisted_29
          ]),
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "btn btn-outline-secondary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.cancelcadlink()))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "ban" }),
            _hoisted_30
          ])
        ])
      ])
    ], 512), [
      [_vShow, $setup.janela]
    ])
  ]))
}